<template>
  <div style="width: 100%;">
    <div class="d-flex flex-column">
      <h1>RFID V1</h1>
      <h1>{{this.instruction}}</h1>
      <v-btn class="mb-3" block x-large color="success" to="/RFID/register">REGISTER</v-btn>
      <v-btn class="mb-3" block x-large color="info" to="/RFID/track">TRACK</v-btn>
      <v-btn class="mb-3" block x-large color="warning" to="/RFID/deregister">DEREGISTER</v-btn>
      <span>
        <v-progress-circular
          indeterminate
          color="green"
          v-if="loading"
      ></v-progress-circular>
      </span>
    </div>
    <v-snackbar style="margin-bottom: 60px;" v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  // import axios from 'axios';
  // import scanSystem from '../../plugins/scanSystem';
  import {mapGetters, mapMutations} from "vuex";

  export default {
    data () {
      return {
        instruction: "",
        quantityRules: [
          v => v>=0 || 'Must be more than or equal 0'
        ],
        loading: false,
        product: undefined,
        snackObj: {
          state: false,
          color: '',
          text: ''
        }
      }
    },
    async mounted(){
      try {
       console.log('Mounted')
      } catch (error) {
        console.log(error)
        this.snack(error)
      }
    },
    computed: {
      ...mapGetters(['getEndpoint', 'isAllowed', 'scanBus', 'getGlobalValue']),
    },
    methods: {
      ...mapMutations([
        'setScanBus',
        'resetScanBus',
      ]),
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
    },
  }
</script>
